import React, { useState } from 'react'
import { useLocation } from 'react-router-dom'
import LoginForm from './LoginForm'
import ForgotPasswordForm from './ForgotPasswordForm'
import ResetPasswordForm from './ResetPasswordForm'
import AuthPageWrapper from './AuthPageWrapper'

type AuthView = 'login' | 'forgot-password' | 'reset-password'

const AuthContainer: React.FC = () => {
  const location = useLocation()
  const [currentView, setCurrentView] = useState<AuthView>('login')

  // Verifică dacă suntem pe ruta de reset parolă
  React.useEffect(() => {
    const searchParams = new URLSearchParams(location.search)
    if (searchParams.get('token')) {
      setCurrentView('reset-password')
    }
  }, [location])

  const handleShowForgotPassword = () => {
    setCurrentView('forgot-password')
  }

  const handleBackToLogin = () => {
    setCurrentView('login')
  }

  const renderCurrentView = () => {
    switch (currentView) {
      case 'login':
        return (
          <LoginForm
            onShowForgotPassword={handleShowForgotPassword}
          />
        )
      
      case 'forgot-password':
        return (
          <ForgotPasswordForm
            onBackToLogin={handleBackToLogin}
          />
        )
      
      case 'reset-password':
        return <ResetPasswordForm />
      
      default:
        return (
          <LoginForm
            onShowForgotPassword={handleShowForgotPassword}
          />
        )
    }
  }

  return (
    <AuthPageWrapper>
      {renderCurrentView()}
    </AuthPageWrapper>
  )
}

export default AuthContainer
